<template>
    <button 
        ref="switchRef" 
        type="button" 
        role="switch" 
        :aria-checked="modelValue"
        :data-state="modelValue ? 'checked' : 'unchecked'" 
        :disabled="disabled" 
        @click="toggle"
        class="toggle-switch"
    >
        <span class="toggle-switch-thumb" :data-state="modelValue ? 'checked' : 'unchecked'" />
    </button>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

const switchRef = ref(null)

const toggle = () => {
    if (!props.disabled) {
        emit('update:modelValue', !props.modelValue)
    }
}
</script>

<style scoped>
.toggle-switch {
    position: relative;
    display: inline-flex;
    height: 24px;
    width: 44px;
    flex-shrink: 0;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    border-radius: 9999px;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    background-color: #e5e7eb;
    outline: none;
    vertical-align: middle;
}

.toggle-switch:focus-visible {
    outline: 2px solid #a11128;
    outline-offset: 2px;
}

.toggle-switch:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.toggle-switch[data-state="checked"] {
    background-color: #a11128;
}

.toggle-switch[data-state="unchecked"] {
    background-color: #e5e7eb;
}

.toggle-switch-thumb {
    pointer-events: none;
    display: block;
    height: 20px;
    width: 20px;
    border-radius: 9999px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.toggle-switch-thumb[data-state="checked"] {
    transform: translateX(20px);
}

.toggle-switch-thumb[data-state="unchecked"] {
    transform: translateX(0);
}
</style>
